import { useState, useEffect } from 'react';
import { RedocStandalone } from 'redoc';
import { theme } from 'redark-theme';
import styles from './ApiDocs.module.css';
import { Search, Copy, CheckCircle } from 'lucide-react';
import PageLayout from '@/components/layout/PageLayout';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import CodeBlock from '@/components/ui/code-block';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
const SWAGGER_URL = import.meta.env.VITE_API_URL.slice(0, -4) + '/swagger/v1/swagger.json';

const ApiDocs = () => {
  // Hide outer page scrollbar on this page so only ReDoc scrollbars show
  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);
  // Handle hash changes for smooth scrolling to specific API sections
  return (
    <PageLayout 
      title="API Documentation" 
      description="Complete reference for the Recallio Compliance-First Memory API"
    >
      <div className={`w-full ${styles.apiDocsContainer} h-full overflow-hidden`}>
      <Card className="mb-6 h-full flex flex-col">
              <CardHeader>
                <CardTitle>📚 Explore Examples & SDKs</CardTitle>
                <CardDescription>
                  Check out our GitHub repository for complete Node.js and Python SDK examples, integration guides, and best practices.<br/>
                  Explore all endpoints, request/response schemas, and authentication methods or use the <b><u><a href="https://app.recallio.ai/swagger" target="_blank">Swagger UI</a></u></b> to test your requests.
                </CardDescription>
              </CardHeader>
              <CardContent className="p-0 flex-1 min-h-0">
                <div className="flex justify-start">
                  <Button variant="outline" asChild style={{backgroundColor: '#83ffd5', color: 'black'}}>
                    <a href="https://github.com/RecallIO/recallio" target="_blank">
                      <span>View on GitHub</span>
                    </a>
                  </Button>
                  <Button variant="outline" asChild style={{backgroundColor: '#83ffd5', color: 'black'}}>
                    <a href="https://app.recallio.ai/swagger" target="_blank">
                      <span>Swagger UI</span>
                    </a>
                  </Button>
                </div>
                <div className={`w-full h-full ${styles.redocContainer}`}>
                  <RedocStandalone 
                    specUrl={SWAGGER_URL}
                    options={{
                      theme: theme,
                      //scrollYOffset: 60,
                      hideDownloadButton: false,
                      disableSearch: false,
                      hideHostname: false,
                      expandResponses: '200,201',
                      requiredPropsFirst: true,
                      sortPropsAlphabetically: true,
                      showExtensions: true,
                      pathInMiddlePanel: true,
                      menuToggle: true
                    }}
                  />
                </div>
              </CardContent>
            </Card>
      </div>
    </PageLayout>
  );
};

export default ApiDocs;
